import unzip from 'lodash/unzip';
import first from 'lodash/first';
import tail from 'lodash/tail';
import {readFile, read, utils} from 'xlsx';

export default (file, lang, sheetNumber) => {
    const workbook = typeof window === 'undefined' ? readFile(file) : read(file, { type: 'binary' });
    const sheetNames = workbook.SheetNames;
    if (sheetNames.length === 0) {
        return Promise.reject({ error: 'Es wurden keine Daten auf dieser Seite gefunden.' });
    }
    const sheets = workbook.Sheets;
    const json = utils.sheet_to_json(sheets[sheetNames[sheetNumber]], {
        header: 1,
        defVal: '',
        blankrows: false,
    });

    if (json.length === 0) {
        return Promise.reject({ error: 'Es wurden keine Daten auf dieser Seite gefunden.' });
    }

    const transposedMatrix = unzip(json);
    const normalizedOutput = transposedMatrix
        .map(columnRows => ({
            name: first(columnRows),
            data: tail(columnRows),
        }))
        .filter(column => column.data.length === 0 || !column.data.every(data => data === undefined));

    return Promise.resolve({ worksheet: normalizedOutput });
};
